import styles from './styles.module.css';

const AperturaContainerXL = (props) => {
//console.log(props);
    return (
        // Div Contenedor padre
        <div className={`${styles["AperturaContainerXL-parent"]}`}> 
            <div className={`${styles['primer-bloque']}`}>
                {props.renderContainerWidgetCallback(1, "ModuloDestacadoXL",{hasBackground: props.hasBackground})}
            </div>
            
        </div>
    )
}

export default AperturaContainerXL;